import {GenericoTipoEnum} from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum TipoCancelamento {
  Outros = 1,
  ConsideroComissaoBaixa = 2,
  ValorPropostaNaoAceitaPeloCliente = 3,
  VendidoParaConcorrente = 4,
  // Outros = 'Outros',
  // ConsideroComissaoBaixa = 'ConsideroComissaoBaixa',
  // ValorPropostaNaoAceitaPeloCliente = 'ValorPropostaNaoAceitaPeloCliente',
  // VendidoParaConcorrente = 'VendidoParaConcorrente',
}

export class TipoCancelamentoEnum extends GenericoTipoEnum<TipoCancelamento> {
  static readonly Outros = new TipoCancelamentoEnum(TipoCancelamento.Outros, 'Outros');
  static readonly ConsideroComissaoBaixa = new TipoCancelamentoEnum(TipoCancelamento.ConsideroComissaoBaixa, 'Considero a comissão baixa');
  static readonly ValorPropostaNaoAceitaPeloCliente = new TipoCancelamentoEnum(TipoCancelamento.ValorPropostaNaoAceitaPeloCliente, 'Valor de proposta não aceita pelo cliente');
  static readonly VendidoParaConcorrente = new TipoCancelamentoEnum(TipoCancelamento.VendidoParaConcorrente, 'Vendido para o concorrente');
}
